<template>
  <div class="search">
    <Form label-position="top" ref="form" :model="formData">
      <Row type="flex" :gutter="80">
        <Col :span="6">
          <FormItem label="部门类别" prop="deptType">
            <Select  v-model="formData.deptType" >
                <Option v-for="item in depts" :value="item.id" :key="item.id">
                    {{item.dicName}}
                </Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="部门名称" prop="deptName">
            <Input  v-model="formData.deptName"  />
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import api from '../../../api/index'
const {getDeptList} = api
export default {
  props: ['depts'],
    data() {
        return {
          formData: {
            deptType: '',
            deptName: ''
          }
        }
    },
    created() {
        
    },
    methods: {
        reset() {
          this.$refs.form.resetFields()
        }
    }
};
</script>

<style>
.search {
  background: #fff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 24px 20px 0 20px;
}
</style>